








































































































































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";

@Component({
    components: {
        EstateCard: () => import("./card.vue"),
        ElSelect: () => import("../../components/forms/select.vue"),
        ElPriceSelect: () => import("../../components/forms/price-select.vue"),
        FormCheckbox: () => import("../forms/Checkbox.vue")
    }
})
export default class EstatesFilter extends Vue {
    @Prop({ default: ":count panden" }) title?: string;

    @Prop({ default: true }) showBanner?: boolean;

    @Prop({ default: () => {} }) preset?: SweepbrightParams;

    @Ref() locationSelect?: SelectClass;

    @Ref() typeSelect?: SelectClass;

    @Ref() bedroomSelect?: SelectClass;

    @Ref() priceSelect?: SelectClass;

    @Prop({
        default: () => {
            show_location: true;
            show_bedrooms: true;
            show_price: true;
            show_type: true;
            show_sale_or_let: true;
        }
    })
    filters?: SweepbrightFilters;

    loading = false;

    open = false;

    params: SweepbrightParams = {
        per_page: 15,
        page: 1,
        type: "",
        bedrooms: "",
        sale_or_let: "sale",
        sort: "created_at,desc",
        cities: "",
        zips: "",
        price: false,
        min: 0,
        is_project: false,
        is_unit: undefined
    };

    pageData = {
        current: 1,
        next: 2,
        last: 1,
        total: 0
    };

    estates: Estate[] = [];

    cityOptions: SelectOption[] = [];

    typeOptions: SelectOption[] = [
        { id: 1, value: "house", label: "Woning" },
        { id: 2, value: "apartment", label: "Appartement" },
        { id: 3, value: "parking", label: "Parking" },
        { id: 4, value: "land", label: "Grond" },
        { id: 5, value: "office", label: "Kantoor" }
    ];

    bedroomOptions: SelectOption[] = [
        { id: 1, value: "1", label: "1+ slaapkamers" },
        { id: 2, value: "2", label: "2+ slaapkamers" },
        { id: 3, value: "3", label: "3+ slaapkamers" },
        { id: 4, value: "4", label: "4+ slaapkamers" }
    ];

    priceOptions: SelectOption[] = [
        { id: 1, label: "< €100.000", value: "0_100000" },
        { id: 2, label: "€100.000 - €200.000", value: "100000_200000" },
        { id: 3, label: "€200.000 - €300.000", value: "200000_300000" },
        { id: 4, label: "€300.000 - €400.000", value: "300000_400000" },
        { id: 5, label: "€400.000 - €500.000", value: "400000_500000" },
        { id: 6, label: "> €500.000", value: "500000" }
    ];

    sortOptions: SelectOption[] = [
        { id: 1, value: "created_at,desc", label: "Nieuwste eerst" },
        { id: 2, value: "price->amount,asc", label: "Laagste prijs eerst" },
        { id: 3, value: "price->amount,desc", label: "Hoogstre prijs eerst" }
    ];

    getMobileEstates() {
        this.params.per_page = 4;
        this.estates = [];
        this.getEstates();
    }

    @Debounce(500)
    handleFilterChanged() {
        if (window.outerWidth > 400) {
            this.estates = [];
            this.getEstates();
        }
    }

    get computedTitle() {
        if (!this.title) {
            return "";
        }

        return this.title.replace(":count", `${this.pageData.total}`);
    }

    private mounted() {
        if (window.outerWidth < 800) {
            this.params.per_page = 4;
        }
        this.getCities().then(() => {
            this.setParams();
            this.getEstates();
        });
    }

    private setParams() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());

        if (params.sale_or_let && (params.sale_or_let === "sale" || params.sale_or_let === "let")) {
            this.params.sale_or_let = params.sale_or_let;
        }

        if (params.bedrooms) {
            params.bedrooms.split(",").forEach((bedroom: string) => {
                const matchedBedroom = this.bedroomOptions.find((option: SelectOption) => option.value === bedroom);
                if (matchedBedroom) {
                    this.params.bedrooms = `${bedroom}`;
                }
            });
        }

        if (params.price) {
            params.price.split(",").forEach((price: string) => {
                const matchedPrice = this.priceOptions.find((option: SelectOption) => option.value === price);

                if (matchedPrice) {
                    this.params.price = `${price}`;
                }
            });
        }

        if (params.type) {
            params.type.split(",").forEach((type: string) => {
                const matchedType = this.typeOptions.find((option: SelectOption) => option.value === type);
                if (matchedType) {
                    // @ts-ignore
                    this.params.type = `${type}`;
                }
            });
        }

        if (params.zips) {
            this.params.zips = params.zips;
        }
    }

    private loadMore() {
        this.params.page = this.pageData.next;
        this.getEstates();
    }

    private getEstates() {
        const params = { ...this.params, ...this.preset };

        if (this.params.sale_or_let !== "") {
            params.sale_or_let = this.params.sale_or_let;
        }

        if (this.params.price) {
            let [min, max] = `${this.params.price}`.split("_");
            params.min = Number(min);
            if (max) {
                params.max = Number(max);
            }
        }

        delete params.price;

        this.loading = true;
        // @ts-ignore
        axios
            .get("/api/estates", { params })
            .then((response: { data: PaginatedEstates }) => {
                this.pageData.current = response.data.current_page;
                this.pageData.next = response.data.current_page + 1;
                this.pageData.last = response.data.last_page;
                this.pageData.total = parseInt(response.data.total, 10);
                this.addOrSetEstates(response.data);

                let query = `?sale_or_let=${this.params.sale_or_let}`;
                if (this.params.type) {
                    query += `&type=${this.params.type}`;
                }
                if (this.params.cities) {
                    query += `&cities=${this.params.cities}`;
                }
                if (this.params.zips) {
                    query += `&zips=${this.params.zips
                        .split(",")
                        .filter((v, i, a) => a.indexOf(v) === i)
                        .join(",")}`;
                }

                if (this.params.price) {
                    query += `&price=${this.params.price}`;
                }
                if (this.params.bedrooms) {
                    query += `&bedrooms=${this.params.bedrooms}`;
                }

                //@ts-ignore
                if (history.pushState) {
                    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + query;
                    window.history.pushState({ path: newurl }, "", newurl);
                }
            })
            .finally(() => {
                this.loading = false;
                this.open = false;
            });
    }

    private async getCities() {
        // @ts-ignore
        return axios.get("/api/zips").then((response: any) => {
            const ziplist = response.data;

            // @ts-ignore
            this.cityOptions = [];

            Object.keys(ziplist).forEach((index: string) => {
                let match: any = ziplist[index];
                let option: any = {
                    id: match.filter,
                    label: `${match.city}`,
                    tagLabel: `${match.city} (${match.zip})`,
                    selectedLabel: `<span class='flex flex-row items-center gap-[4px]'><span>${match.city}</span><small class='text-red'>${match.zip}</small></span>`,
                    value: match.filter
                };

                if (match.children) {
                    option.children = [];
                    match.children.forEach((childList: any) => {
                        option.children.push({
                            id: childList.zip,
                            parent_id: match.zip,
                            label: `${childList.city} ${childList.zip}`,
                            tagLabel: `${childList.city} (${match.zip})`,
                            indent: true,
                            selectedLabel: `<span class='flex flex-row items-center gap-[4px] ml-16'><span>${childList.city}</span><small class='text-red'>${childList.zip}</small></span>`,
                            value: childList.filter
                        });
                    });

                    option.children.sort((a: any, b: any) => {
                        return a.label.localeCompare(b.label);
                    });
                }

                this.cityOptions.push(option);
            });

            this.cityOptions.sort((a: any, b: any) => {
                return a.label.localeCompare(b.label);
            });
        });
    }

    private addOrSetEstates(estates: PaginatedEstates) {
        this.estates = [...this.estates, ...estates.data];
    }
}
